import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

const GET_CONDITIONS = gql`
    query GetConditions {
        conditions {
            uuid
            type
            publishedVersionNumber
            versions {
                uuid
                versionNumber
                createdAt
                publishedAt
            }
        }
    }
`;

const useConditions = ({skip = false} = {}) => {
    const {loading, error, data, refetch} = useQuery(GET_CONDITIONS, {
        fetchPolicy: 'network-only',
        skip,
    });

    return {
        loading,
        error,
        conditions: data?.conditions,
        refetch,
    };
};

export default useConditions;